const mutedMethods = ['log', 'info', 'debug', 'warn'];

if (process.env.NODE_ENV === 'production' && typeof console !== 'undefined') {
  mutedMethods.forEach(method => {
    console[method] = () => {};
  });
}
